import * as React from 'react';
import { Props } from './props';
import { Placeholder } from 'semantic-ui-react';

import './styles.css';

export default class FormPlaceholder extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  render() {
    const defaultCount = 4;
    let count: number = defaultCount;
    if (this.props.count) {
      count = this.props.count;
    }

    let array = [];
    for (let i = 0; i < count; i++) {
      array.push(`${i}`);
    }
    
    return (
      <Placeholder>
        {array.map((value) => (
          <React.Fragment key={'placeholderFrag' + value}>
            <Placeholder.Line length={'short'} className="label" key={'label' + value} />
            <Placeholder.Line length={'full'} className="input" key={'input' + value} />
          </React.Fragment>
        ))}
      </Placeholder >
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/form-placeholder/component.tsx